/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsDateSchedulesCsvValidateMutationResponse, AuditMentionsAuditMentionsDateSchedulesCsvValidateQueryParams } from "../models/AuditMentionsAuditMentionsDateSchedulesCsvValidate";

export function getAuditMentionsAuditMentionsDateSchedulesCsvValidateUrl() {
  const res = { method: 'POST', url: `/audit-mentions/v1/date-schedules/csv-validate` as const }
  return res
}

/**
 * @description Validates a CSV file of mention date schedules without importing.
 * @summary Validate mention date schedules CSV
 * {@link /audit-mentions/v1/date-schedules/csv-validate}
 */
export async function auditMentionsAuditMentionsDateSchedulesCsvValidate(params: AuditMentionsAuditMentionsDateSchedulesCsvValidateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditMentionsAuditMentionsDateSchedulesCsvValidateMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAuditMentionsAuditMentionsDateSchedulesCsvValidateUrl().url.toString(), params, ... requestConfig })
  return res.data
}